import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-wider mb-2">HOT RANKING</p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">热度排行</h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            实时更新吃瓜网站最热门话题，追踪每日热搜动态
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingData.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className={`flex items-center gap-4 px-4 py-4 rounded-lg transition-colors cursor-pointer group ${
                i % 2 === 0 ? 'bg-background-100/60' : ''
              } hover:bg-background-100`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
              </div>
              {item.tag && (
                <span className={`text-xs font-semibold px-2 py-0.5 rounded whitespace-nowrap ${
                  item.tag === '爆' ? 'bg-primary-500 text-white' :
                  item.tag === '热' ? 'bg-accent-500 text-white' :
                  'bg-secondary-500 text-white'
                }`}>
                  {item.tag}
                </span>
              )}
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}